/* AROL: acordeón de Sucursales. Independiente del editor de contenido y del JS del tema. */
(function () {
  'use strict';
  function routeCity(item) {
    var button = item.querySelector('.city-accordion-btn');
    if (!button) return;
    var match = button.textContent.match(/\b(Monterrey|Saltillo|Monclova|Chihuahua|Reynosa)\b/i);
    if (!match) return;
    var city = match[0], contact = document.querySelector('[data-arol-branch-directory] [data-city="' + city.toLowerCase() + '"]');
    if (!contact || !/^\d{10,15}$/.test(contact.dataset.phone)) return;
    item.querySelectorAll('.sucursal-card').forEach(function (card) {
      var title = card.querySelector('h3');
      if (!title) return;
      card.querySelectorAll('a.btn-wa').forEach(function (link) {
        var branch = title.textContent.trim();
        link.href = 'https://wa.me/' + contact.dataset.phone + '?text=' + encodeURIComponent('Hola, quisiera información de la sucursal ' + branch + ' en ' + city + '.');
        link.setAttribute('data-arol-wa-preserve','');
        link.setAttribute('data-arol-wa-number',contact.dataset.phone);
        link.setAttribute('aria-label','WhatsApp de ' + branch + ' · ' + contact.dataset.person + ' (se abre en una pestaña nueva)');
        link.target = '_blank';link.rel = 'noopener';
        var label = link.querySelector('.arol-wa-line__text');
        if (label) label.textContent = 'WhatsApp · ' + contact.dataset.person;
        else link.textContent = 'WhatsApp · ' + contact.dataset.person;
      });
    });
  }
  function init() {
    document.querySelectorAll('.sucursales-accordion-container').forEach(function (container, groupIndex) {
      container.querySelectorAll('.city-accordion-item').forEach(routeCity);
      if (container.hasAttribute('data-arol-sucursales-ready')) return;
      container.querySelectorAll('.city-accordion-item').forEach(function (item, index) {
        var button = item.querySelector('.city-accordion-btn');
        var content = item.querySelector('.city-accordion-content');
        if (!button || !content) return;
        content.id = content.id || 'arol-sucursales-' + groupIndex + '-' + index;
        button.type = 'button';
        button.setAttribute('aria-controls', content.id);
        button.setAttribute('aria-expanded', 'false');
        content.hidden = true;
        var icon = button.querySelector('.icon');
        if (icon) icon.setAttribute('aria-hidden', 'true');
        button.addEventListener('click', function () {
          var open = button.getAttribute('aria-expanded') !== 'true';
          button.setAttribute('aria-expanded', String(open));
          content.hidden = !open;
          if (icon) icon.textContent = open ? '−' : '+';
        });
      });
      container.setAttribute('data-arol-sucursales-ready', '');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
}());
